import React from 'react'
import { FooterStyle } from './Footer.styled'
import CopyRightDiv from '../CopyRight/CopyRightDiv'

function Footer({style="footer"}) {
  return (
    <FooterStyle>
        <div className={style}>
            <div className="footerNest">
                <div className='footerBrand'>
                    <img src="ocufii_rev_mark.png" alt="footer_img" className={style==="footer"?"footer_img":"footer_img2"} />
                </div>
                <ul className='foot_links'>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/about" className='footer_options'>About</a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/solutions/tagme" className='footer_options'>Solutions</a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/invest-in-ocufii" className='footer_options'>Investment Opportunity</a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/authorized-partners" className='footer_options'>Authorized Partners</a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/become-a-reseller" className='footer_options'>Become a Reseller</a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/shop/preorder" className='footer_options'>Preorder TagMe</a>
                    </li>
                </ul>
                <ul className='foot_social'>
                    <li className='foot_links_child'>
                    <a href="https://www.linkedin.com/company/ocufii/" title='linkedin'><i className={`bi bi-linkedin ${style==="footer"?"social":"social social2"}`}></i></a>
                    <a href="https://www.twitter.com/ocufii" title='twitter'><i className={`bi bi-twitter ${style==="footer"?"social":"social social2"}`}></i></a>
                    <a href="https://www.facebook.com/people/ocufii/100090498976698/" title='facebook'><i className={`bi bi-facebook ${style==="footer"?"social":"social social2"}`}></i></a>
                    </li>
                    <li className='foot_links_child'>
                    <a href="https://ocufii.com/terms" className='footer_options'>Terms of Service</a>
                    </li>
                    <li className='foot_links_child'><a href="https://ocufii.com/privacy" className='footer_options'>Privacy Policy</a></li>
                    <li className='foot_links_child'><a href="https://ocufii.com/faqs" className='footer_options'>Privacy Policy FAQs</a></li>
                </ul>
            </div>
            
            <CopyRightDiv />
        </div>
        
        
    </FooterStyle>
  )
}

export default Footer